import React, { useEffect, useState } from "react";
import NavbarLandingPage from "../../NavbarLandingPage";
import CategoryGallery from "./CategoryGallery";
import Footer from "../../../Footer";
import { Link, useLocation, useParams } from "react-router-dom";
import { collectData } from "../../../../utilities";
import loadingspiner from "../../images/icons8-rhombus-loader.gif";
import axios from "axios";
import OwlCarousel from "react-owl-carousel-rtl";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const ServicesDetails = () => {
  const location = useLocation();
  const [object, setObject] = useState(location.state?.category);
  const [isLoading, setIsLoading] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const handleClick = () => {
    setIsActive((current) => !current);
  };

  const { type, id } = useParams();
  useEffect(() => {
    if (object == null) {
      axios({
        method: "get",
        url: `https://us-central1-zifaf-app.cloudfunctions.net/webapp/api/services/${type}/${id}`,
        responseType: "json",
      }).then((response) => {
        const collectedData = collectData(type, [response.data])[0];
        setObject(collectedData);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);
  if (isLoading) {
    return (
      <div className="spinner-loading">
        <img src={loadingspiner} />
      </div>
    );
  }
  if (object == null || Object.keys(object).length === 0) {
    return;
  }
  let logo = object.logo;
  return (
    <div>
      <div className="landing-page">
        <NavbarLandingPage />
        <div className="category-details">
          <div className="category-head-section-right ">
            <div
              className="category-img-wrap"
              style={{ backgroundImage: 'url("' + logo + '")' }}
            ></div>
            <div className="category-name-and-place">
              <div className="category-name">
                <p>{object.name}</p>
              </div>
              {object.address ? (
                <div className="category-place">
                  <div className="business-address">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 28 40"
                      fill="none"
                    >
                      <path
                        d="M14.1496 1.04297C6.5372 1.04297 0.380371 7.19979 0.380371 14.8122C0.380371 23.0148 9.07467 34.3252 12.6547 38.633C13.4415 39.5772 14.8774 39.5772 15.6642 38.633C19.2246 34.3252 27.9189 23.0148 27.9189 14.8122C27.9189 7.19979 21.7621 1.04297 14.1496 1.04297ZM14.1496 19.7298C11.4351 19.7298 9.23204 17.5267 9.23204 14.8122C9.23204 12.0977 11.4351 9.89463 14.1496 9.89463C16.8641 9.89463 19.0672 12.0977 19.0672 14.8122C19.0672 17.5267 16.8641 19.7298 14.1496 19.7298Z"
                        fill="#45A89E"
                      />
                    </svg>
                  </div>
                  <p> {object.address}</p>
                </div>
              ) : null}
            </div>
          </div>
          {object.guests ? (
            <div className="category-head-section-left">
              <div className="category-number">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="44"
                  height="38"
                  viewBox="0 0 44 38"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.3711 21.4023C32.8603 23.3785 34.6046 26.0559 34.6046 29.6258V36.0006H41.8725V29.6258C41.8725 24.9935 35.3859 22.2523 30.3711 21.4023Z"
                    fill="#45A89E"
                    stroke="#45A89E"
                    strokeWidth="2.90714"
                  />
                  <path
                    d="M16.4363 18.9994C20.4502 18.9994 23.7042 15.1939 23.7042 10.4997C23.7042 5.80544 20.4502 2 16.4363 2C12.4224 2 9.16846 5.80544 9.16846 10.4997C9.16846 15.1939 12.4224 18.9994 16.4363 18.9994Z"
                    fill="#45A89E"
                    stroke="#45A89E"
                    strokeWidth="2.90714"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.3365 18.9994C31.352 18.9994 34.6043 15.1958 34.6043 10.4997C34.6043 5.80361 31.352 2 27.3365 2C26.4825 2 25.683 2.21249 24.9199 2.50998C26.428 4.69865 27.3365 7.4823 27.3365 10.4997C27.3365 13.5171 26.428 16.3007 24.9199 18.4894C25.683 18.7869 26.4825 18.9994 27.3365 18.9994Z"
                    fill="#45A89E"
                    stroke="#45A89E"
                    strokeWidth="2.90714"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4351 21.126C11.5838 21.126 1.89941 23.9734 1.89941 29.6257V36.0004H30.9709V29.6257C30.9709 23.9734 21.2864 21.126 16.4351 21.126Z"
                    fill="#45A89E"
                    stroke="#45A89E"
                    strokeWidth="2.90714"
                  />
                </svg>
                <p>{object.guests}</p>
              </div>
              <div className="category-mixed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.59352 0.170951C5.92646 0.380693 4.9736 0.913079 4.62039 1.27319C2.88734 3.04084 3.36713 5.68038 5.63855 6.87557C6.44179 7.29814 6.7443 7.36221 7.93801 7.36221C9.13172 7.36221 9.43423 7.29814 10.2375 6.87557C13.1781 5.32837 12.9311 1.63607 9.80243 0.373394C8.93562 0.0234987 7.37525 -0.0749652 6.59352 0.170951ZM25.9701 0.371123C23.2806 1.42876 22.5916 4.43068 24.612 6.28868C25.2153 6.84345 26.8252 7.44007 27.7212 7.44088C30.3418 7.44315 32.4363 5.57023 32.178 3.45562C31.9936 1.94703 31.1399 0.929787 29.5459 0.319539C28.3894 -0.123143 27.183 -0.105786 25.9701 0.371123ZM2.72965 9.77952C2.18917 9.99218 1.52096 10.4162 1.24495 10.7218C0.212959 11.8643 0.15918 12.2257 0.15918 18.0077V23.3403H1.79177H3.42437V30.3966V37.4529H7.93801H12.4517V30.3966V23.3403H14.0842H15.7168V18.0077C15.7168 12.2257 15.6631 11.8643 14.6311 10.7218C14.3551 10.4162 13.6869 9.99218 13.1464 9.77952C12.2047 9.40918 11.9867 9.39313 7.93801 9.39313C3.88937 9.39313 3.67137 9.40918 2.72965 9.77952ZM26.0905 9.59492C25.722 9.69874 25.0641 10.0845 24.6285 10.4522C23.8639 11.098 23.7375 11.3725 20.9292 18.4878C19.3301 22.5396 18.0217 25.9459 18.0217 26.0573C18.0217 26.2116 18.803 26.2601 21.2869 26.2601H24.5521V31.8565V37.4529H27.8172H31.0824V31.8565V26.2601H34.3476C36.832 26.2601 37.6126 26.2116 37.612 26.0573C37.6117 25.9459 36.3229 22.5803 34.7481 18.5783C31.683 10.789 31.5081 10.4649 30.0159 9.81018C29.1247 9.41924 27.1083 9.30861 26.0905 9.59492Z"
                    fill="#45A89E"
                  />
                </svg>
                {object.mix ? <p>Mixed</p> : <p>not Mixed</p>}
              </div>
              <div className="category-scales">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="39"
                  height="39"
                  viewBox="0 0 39 39"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.35903 0.0939759C3.49858 0.626462 1.28669 2.68347 0.507242 5.53587L0.321777 6.2147V19.2954V32.3761L0.507242 33.055C1.23421 35.7153 3.18295 37.662 5.84892 38.3909L6.52002 38.5744H19.6007C31.8071 38.5744 32.7182 38.5649 33.2312 38.4332C35.9337 37.7391 37.9592 35.7428 38.6962 33.0472L38.8797 32.3761V19.2954V6.2147L38.6942 5.53587C37.9715 2.89107 36.0429 0.951668 33.3816 0.193389L32.7619 0.0168601L19.8422 0.0029343C9.52029 -0.00817424 6.80917 0.0101789 6.35903 0.0939759ZM32.6608 2.70786C34.4599 3.16798 35.7282 4.43621 36.1883 6.23531C36.339 6.82446 36.344 7.24804 36.344 19.2954C36.344 31.3428 36.339 31.7664 36.1883 32.3555C35.7282 34.1546 34.4599 35.4228 32.6608 35.883C32.0717 36.0337 31.6481 36.0387 19.6007 36.0387C7.46457 36.0387 7.13373 36.0347 6.52775 35.8797C4.70941 35.4146 3.38001 34.0438 2.97744 32.2186C2.86676 31.7168 2.85501 30.1993 2.87505 19.0137L2.89767 6.3757L3.06889 5.9291C3.54205 4.69452 4.08194 3.99525 5.05933 3.35103C5.55632 3.02341 6.22428 2.74224 6.76151 2.63437C6.9386 2.59879 12.7014 2.56579 19.5677 2.56096C31.6633 2.55234 32.071 2.55693 32.6608 2.70786ZM7.18517 6.54192C6.71507 6.79702 6.72126 6.73052 6.72126 11.4981C6.72126 15.7491 6.72561 15.8728 6.88797 16.2081C7.10652 16.6595 7.49524 16.8991 8.00921 16.8991C8.52318 16.8991 8.9119 16.6595 9.13045 16.2081C9.28822 15.8822 9.29716 15.7281 9.29716 13.3335V10.8033L18.6753 20.181L28.0534 29.5587L25.4571 29.599C22.5624 29.6438 22.5168 29.6523 22.1751 30.2051C21.7831 30.8395 22.0242 31.6867 22.688 32.0082C23.0234 32.1705 23.1471 32.1749 27.398 32.1749C32.1874 32.1749 32.1056 32.1828 32.3581 31.6946C32.4628 31.4919 32.4802 30.8375 32.4802 27.0927C32.4802 22.8418 32.4759 22.7181 32.3135 22.3827C31.8683 21.4631 30.5271 21.449 30.0628 22.3592C29.915 22.6489 29.9043 22.8422 29.9043 25.2287V27.7876L20.5262 18.4098L11.148 9.03209L13.7444 8.99184C16.2362 8.9532 16.352 8.94451 16.6224 8.77603C17.0091 8.5351 17.2044 8.17407 17.2044 7.70027C17.2044 7.19016 16.9635 6.80056 16.5134 6.58265C16.1778 6.42013 16.058 6.41602 11.7872 6.41916C8.06854 6.4219 7.37216 6.4405 7.18517 6.54192Z"
                    fill="#45A89E"
                  />
                </svg>
                <p>{object.area}m2</p>
              </div>
            </div>
          ) : null}
        </div>

        {object.images ? (
          <div className="category-wrappers">
            <OwlCarousel
              className="owl-theme refreshClass"
              nav={false}
              rewind={true}
              autoplay={false}
              margin={50}
              items={1}
              autoHeight={true}
            >
              {object.images.map((imgUrl, index) => (
                <CategoryGallery key={index} gallery={imgUrl} />
              ))}
            </OwlCarousel>
          </div>
        ) : null}

        <div className="category-description-and-userform">
          <div className="category-description">
            <p>{object.description}</p>
          </div>
        </div>
        {object.video ? (
          <div className="category-video">
            <video controls>
              <source
                src={object.video}
                border-radius="28.58px"
                type="video/mp4"
              />
            </video>
          </div>
        ) : null}

        {object.details ? (
          <div>
            {Object.keys(object.details).map((service, index) => {
              const data = object.details[service];
              return (
                <div className="event-type" key={index}>
                  <p>{data.title}</p>
                  <div className="all-types">
                    {Object.keys(data).map((title, index) => {
                      const titleData = data[title];
                      console.log(titleData);
                      if (titleData.active != null && titleData != data.title)
                        return (
                          <div className="types" key={index}>
                            <div className="icons-wrapper">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 12 12"
                                fill="none"
                              >
                                <rect
                                  y="5.65674"
                                  width="8"
                                  height="8"
                                  transform="rotate(-45 0 5.65674)"
                                  fill="#FFC61B"
                                />
                              </svg>
                            </div>
                            <p>{titleData.slush}</p>
                          </div>
                        );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}

        {object.pricedDetails ? (
          <div>
            {Object.keys(object.pricedDetails).map((service, index) => {
              const data = object.pricedDetails[service];
              return (
                <div className="event-type" key={index}>
                  <p>{data.title}</p>
                  <div className="pricedDetails">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 36 35"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.5794 0.440341C17.4533 0.973897 0.8567 17.5774 0.346163 18.6812C-0.501276 20.5133 -0.341209 20.7354 7.33178 28.3811C16.4278 37.4449 14.1339 37.7597 25.9573 25.8253C36.3839 15.3011 35.1197 17.6239 35.1197 8.99035C35.1197 -0.701317 35.8371 0.01502 26.1254 0.0102942C19.4941 0.00709288 19.4941 0.00709331 18.5794 0.440341ZM27.4494 6.11433C29.5417 6.90475 29.8439 9.88504 27.9662 11.2115C26.0767 12.5463 23.4801 11.132 23.5013 8.77967C23.5197 6.73279 25.5173 5.38427 27.4494 6.11433Z"
                        fill="#FFC61B"
                      />
                    </svg>
                    <h5>{data.pricedTitle}₪</h5>
                  </div>
                  <div className="all-types">
                    {Object.keys(data).map((title, index) => {
                      const titleData = data[title];
                      console.log(titleData);
                      if (
                        titleData != data.title &&
                        titleData != data.pricedTitle &&
                        titleData != null
                      )
                        return (
                          <div className="types" key={index}>
                            <div className="icons-wrapper">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 12 12"
                                fill="none"
                              >
                                <rect
                                  y="5.65674"
                                  width="8"
                                  height="8"
                                  transform="rotate(-45 0 5.65674)"
                                  fill="#FFC61B"
                                />
                              </svg>
                            </div>
                            <p>{titleData.slush}</p>
                          </div>
                        );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}

        {object.gallery ? (
          <div className="category-wrappers">
            <div className="gallery-photo">
              <p>جاليري الصور</p>
            </div>
            <OwlCarousel
              className="owl-theme refreshClass"
              nav={false}
              rewind={true}
              autoplay={false}
              margin={10}
              items={1}
            >
              {object.gallery.map((imgUrl, index) => (
                <CategoryGallery key={index} gallery={imgUrl} />
              ))}
            </OwlCarousel>
          </div>
        ) : null}
        <div className="show-price">
          <Link
            to={`/login/${type}/${object.id}`}
          > <button
            style={{
              backgroundColor: isActive ? "#45A89E" : "",
              color: isActive ? "white" : "",
            }}
            onClick={handleClick}

          >
              طلب عرض سعر
            </button></Link>

        </div>
      </div>
      <Footer />
    </div>
  );
};
export default ServicesDetails;
